<div class="cadastro-pesquisador-container">
  <div class="header">
    <h1>Cadastro de Pesquisadores</h1>
    <button class="btn btn-primary" (click)="openModal(formModal, true)">Novo Pesquisador</button>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroCpf">CPF:</label>
          <input 
            type="text" 
            id="filtroCpf" 
            class="form-control" 
            [(ngModel)]="filtroCpf"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por CPF">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroPesquisador">Tipo de Pesquisador:</label>
          <select 
            id="filtroPesquisador" 
            class="form-control" 
            [(ngModel)]="filtroPesquisador"
            (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="pesquisadoR_BRASIL">Brasil</option>
            <option value="pesquisadoR_ITALIA">Itália</option>
            <option value="pesquisadoR_OUTROS">Outros</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-end">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>CPF</th>
          <th>E-mail</th>
          <th>Telefone</th>
          <th>Pais</th>
          <th>Data Cadastro</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pesquisador of pesquisadoresFiltrados">
          <td>{{ pesquisador.nome }}</td>
          <td>{{ pesquisador.cpf }}</td>
          <td>{{ pesquisador.email }}</td>
          <td>{{ pesquisador.telefone }}</td>
          <td>
            <span *ngIf="pesquisador.pesquisadoR_BRASIL" class="badge bg-primary me-1">Brasil</span>
            <span *ngIf="pesquisador.pesquisadoR_ITALIA" class="badge bg-success me-1">Itália</span>
            <span *ngIf="pesquisador.pesquisadoR_OUTROS" class="badge bg-info">Outros</span>
          </td>
          <td>{{ pesquisador.datA_CADASTRO | date:'dd/MM/yyyy' }}</td>
          <td>
            <button class="btn btn-sm btn-warning me-2" (click)="editarPesquisador(pesquisador); openModal(formModal)">
              <i class="fa fa-edit"></i> Editar
            </button>
            <!--<button class="btn btn-sm btn-danger" (click)="excluirPesquisador(pesquisador.id)">
              <i class="fa fa-trash"></i> Excluir
            </button>-->
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header">
      <h4 class="modal-title">{{ pesquisadorSelecionado ? 'Editar Pesquisador' : 'Novo Pesquisador' }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-container">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nomeCompleto">Nome completo:</label>
              <input 
                type="text" 
                id="nomeCompleto" 
                formControlName="nomeCompleto" 
                class="form-control"
                placeholder="Digite o nome completo">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="cpf">CPF:</label>
              <input 
                type="text" 
                id="cpf" 
                formControlName="cpf" 
                class="form-control"
                placeholder="000.000.000-00"
                [textMask]="{mask: cpfMask}">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="email">E-mail:</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="form-control"
                placeholder="seu@email.com">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="telefone">Telefone:</label>
              <input 
                type="text" 
                id="telefone" 
                formControlName="telefone" 
                class="form-control"
                placeholder="(00) 00000-0000"
                [textMask]="{mask: telefoneMask}">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="endereco">Endereço completo:</label>
          <textarea 
            id="endereco" 
            formControlName="endereco" 
            class="form-control"
            placeholder="Digite o endereço completo"
            rows="3"></textarea>
        </div>

        <div class="form-group checkbox-group">
          <label class="mb-2">Tipos de Pesquisador:</label>
          <div class="row">
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="pesquisadorBrasil" formControlName="pesquisadorBrasil" class="form-check-input">
                <label for="pesquisadorBrasil" class="form-check-label">Brasil</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="pesquisadorItalia" formControlName="pesquisadorItalia" class="form-check-input">
                <label for="pesquisadorItalia" class="form-check-label">Itália</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="pesquisadorOutros" formControlName="pesquisadorOutros" class="form-check-input">
                <label for="pesquisadorOutros" class="form-check-label">Outros</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="cadastroForm.get('pesquisadorOutros')?.value">
          <label for="outrosPaises">Informar países:</label>
          <textarea 
            id="outrosPaises" 
            [(ngModel)]="outrosPaises" 
            [ngModelOptions]="{standalone: true}"
            class="form-control"
            placeholder="Digite os países onde você atua como pesquisador"
            rows="2"></textarea>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancelar</button>
          <button type="submit" class="btn btn-primary ms-2" [disabled]="!cadastroForm.valid">Salvar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 